import React, { useMemo } from "react";
import _ from "lodash";

const AppliedFilters = ({
  filters,
  selectedFilters,
  setSelectedFilters,
  appliedFilters,
  setAppliedFilters,
  showFiltersModal,
  setShowFiltersModal,
  filterSelected,
  applyFilters
}) => {
  let width = window.innerWidth;

  const tagsLimit = useMemo(() => {
    return width < 600 ? 3 : 10;
  }, [width]);

  const visibleFilters = useMemo(() => {
    // return appliedFilters.filter( filter => !filter?.children?.length ).slice(0, tagsLimit);
    return appliedFilters.slice(0, tagsLimit);
  }, [selectedFilters, appliedFilters, tagsLimit]);

  const toggleShowFiltersModal = () => {
    setShowFiltersModal(!showFiltersModal);
  };

  const removeFilter = payload => {
    let newFilters;
    const payloadKey = payload.parentKey || payload.key || '';
    const parentFilter = filters[ payload.group ].find( filter => filter.key === payloadKey );
    filterSelected( false, payload, true, parentFilter );
    if( payloadKey ) {
      newFilters = selectedFilters.filter(f => f.key !== payload.key && f.key !== parentFilter?.key );
    } else {
      newFilters = selectedFilters.filter(f => f.key === parentFilter?.key );
      for( let i = 0; i < parentFilter?.children.length; i++ ) {
        const selectedFilter = newFilters.find( f => f.key === parentFilter.children[i].key );
        if( selectedFilter ) {
          const index = newFilters.indexOf( selectedFilter );
          newFilters.splice( index, 1 );
        };
      }
    }
    setSelectedFilters( newFilters );
    setAppliedFilters( newFilters );
  };

  const truncatePill = title => {
    return _.truncate(title, {
      length: 20,
      separator: " "
    });
  };

  const clearFilters = () => {
    setAppliedFilters([]);
    setSelectedFilters([]);
  };

  const hideFiltersModal = () => {
    setSelectedFilters(appliedFilters); // Rollback
    toggleShowFiltersModal();
  };

  const showFiltersList = () => {
    setSelectedFilters([...appliedFilters]);
    toggleShowFiltersModal();
  };

  window.addEventListener("resize", () => {
    width = window.innerWidth;
  });

  const styles = {
    btn: { backgroundColor: "#2B00BC", color: "white" },
    mainColor: { color: "#2B00BC" }
  };

  return (
    <div className="w-full bg-gray-100">
      <div
        className="container mx-auto pt-5 px-10 md:px-3"
        style={{ fontFamily: "pressura" }}
      >
        <div className="flex justify-between flex-wrap md:flex-no-wrap">
          {visibleFilters.length > 0 ? (
            <div>
              <div className="inline-block text-gray-500 mr-3">
                APPLIED FILTERS
              </div>

              {visibleFilters.map((payload, index) => (
                <div
                  className="applied-filter inline-block cursor-pointer px-4 py-1 bg-transparent border-blue-700 text-blue-700 hover:text-white border text-sm rounded-full mr-2 mt-1"
                  key={index}
                  onClick={() => removeFilter(payload)}
                >
                  <span className="mr-1">{truncatePill(payload.title)}</span>
                  <i className="fas fa-times"></i>
                </div>
              ))}

              {appliedFilters.length > tagsLimit && (
                <div
                  className="inline-block cursor-pointer"
                  style={styles.mainColor}
                  onClick={() => showFiltersList()}
                >
                  See All
                </div>
              )}
              <div
                className="inline-block cursor-pointer"
                style={{ ...styles.mainColor, marginLeft: "10px" }}
                onClick={() => clearFilters()}
              >
                Clear All
              </div>
            </div>
          ) : (
            <div>&nbsp;</div>
          )}
          {showFiltersModal && (
            <div className="hidden md:flex md:flex-no-wrap items-center mt-5 md:mt-0">
              <span
                className="cursor-pointer mr-3"
                style={styles.mainColor}
                onClick={() => hideFiltersModal()}
              >
                Cancel
              </span>
              <button
                className="btn py-3 px-4"
                style={styles.btn}
                onClick={() => applyFilters()}
              >
                APPLY
              </button>
            </div>
          )}
        </div>

        {showFiltersModal && (
          <div className="md:hidden flex flex-no-wrap items-center justify-end mt-5 md:mt-0">
            <span
              className="cursor-pointer mr-3"
              style={styles.mainColor}
              onClick={() => hideFiltersModal()}
            >
              Cancel
            </span>
            <button
              className="btn py-3 px-4"
              style={styles.btn}
              onClick={() => applyFilters()}
            >
              APPLY
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppliedFilters;
